import { DokumenTindakLanjutStep1 } from 'app/KinerjaPage/pages/PelaksanaanV2/DokumenTindakLanjut/DokumenTindakLanjutStep1'
import { PageGuardPelaksanaan } from 'app/KinerjaPage/pages/PelaksanaanV2/components/PageGuardPelaksanaan'
import KinerjaLayout from 'app/KinerjaShared/components/KinerjaLayout'
import { TOGGLE_KEYS } from 'configs/toggle-feature'
import { getServerSidePropsWithToggle } from 'utils/toggle.server'
import { PageGuardPelaksanaanDate } from 'app/KinerjaPage/pages/PelaksanaanV2/components/PageGuardPelaksanaanDate'

import type { TToggleKeyValuePair } from 'configs/toggle-feature'
import type { NextPageContext } from 'next'

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: TOGGLE_KEYS.filter((key) => key.includes('kinerja')),
  serverProps: async (
    _context: NextPageContext,
    toggle: TToggleKeyValuePair
  ) => {
    const isKinerjaEnabled = toggle?.['kinerja-enabled'] || false
    const isKinerjaPelaksanaanEnabled =
      toggle?.['kinerja-pelaksanaan-enabled'] || false

    if (!isKinerjaEnabled || !isKinerjaPelaksanaanEnabled) {
      return {
        redirect: {
          destination: '/404',
          permanent: false,
        },
      }
    }
  },
})

export default function Page() {
  return (
    <PageGuardPelaksanaanDate>
      <PageGuardPelaksanaan pageState="DOCUMENT_FOLLOW_UP">
        <div className="px-8 pb-8 bg-gray-10 min-h-full">
          <div className="pt-14 max-w-6xl mx-auto">
            <DokumenTindakLanjutStep1 />
          </div>
        </div>
      </PageGuardPelaksanaan>
    </PageGuardPelaksanaanDate>
  )
}

Page.Layout = KinerjaLayout

Page.layoutOpts = {
  hasHeader: true,
}
